<script lang="ts">
  import { Card, Col, Image } from "sveltestrap";
  import UserDesignation from "./UserDesignation.svelte";
  import Link from "svelte-link";
  let imgPath:string = "/assets/images"
</script>

<Col sm="12">
  <Card class="profile-header">
    <Image fluid
      class="bg-img-cover"
      src="{imgPath}/user-profile/bg-profile.jpg"
      alt=""
    />
    <div class="profile-img-wrrap">
      <Image fluid
        class="bg-img-cover"
        src="{imgPath}/user-profile/bg-profile.jpg"
        alt=""
      />
    </div>
    <div class="userpro-box">
      <div class="img-wrraper">
        <div class="avatar">
          <Image fluid alt="" src="{imgPath}/user/7.jpg" />
        </div>
        <Link class="icon-wrapper" href="/users/usersedit">
            <i class="icofont icofont-pencil-alt-5" />
        </Link>
      </div>
      <UserDesignation />
    </div>
  </Card>
</Col>
